import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Target } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

const FirstWinGoalNudge = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleSetGoal = () => {
    onClose();
    navigate('/goals');
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md text-center">
        <DialogHeader>
          <div className="flex justify-center mb-3">
            <div
              className="w-14 h-14 rounded-full flex items-center justify-center"
              style={{ backgroundColor: '#f5f0e8' }}
            >
              <Target className="w-7 h-7" style={{ color: '#C4A35A' }} />
            </div>
          </div>
          <DialogTitle
            className="text-xl font-bold text-center"
            style={{ color: '#1F2A44' }}
          >
            Your first win is in.
          </DialogTitle>
        </DialogHeader>

        <p className="text-sm text-gray-600 mt-1 mb-6 leading-relaxed">
          Wins mean more when they're tied to something. What are you working
          toward? Set a goal now and every future win you log will build toward it.
        </p>

        <div className="flex flex-col gap-3">
          <Button
            onClick={handleSetGoal}
            className="w-full font-semibold"
            style={{ backgroundColor: '#1F2A44', color: '#ffffff' }}
          >
            Set my first goal →
          </Button>
          <button
            onClick={onClose}
            className="text-sm text-gray-400 hover:text-gray-600 transition-colors"
          >
            Maybe later
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FirstWinGoalNudge;
